
import Rater from 'vux/src/components/rater/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
export default {
data(){
return {

serviceGrade:'',
evaluationDmDisabled:false,
serviceHospital:'',
msgForm:{
score:0,
dissatisfiedContent:'',
satisfiedContent:'',

},
UnsatisfiedItemsData:[],
satisfiedItemsData:[],
UnsatisfiedOptions:[],
satisfiedOptions:[],
}
},
components: {
Rater, Radio, Group, Cell,XTextarea,XButton, PopupRadio, Checker, CheckerItem
},
methods:{
Unsatisfiedprojectcheck(value){
let cutteValue = value[value.length-1];

for(let i =0;i<this.satisfiedItemsData.length;i++){
if(cutteValue == this.satisfiedItemsData[i]){

this.UnsatisfiedItemsData = this.UnsatisfiedItemsData.splice(0,value.length-1)
promptMessage('提示','您选择的不满意项目与满意项目冲突,请重新选择！');
}
}
},
satisfiedprojectcheck(value){
let cutteValue = value[value.length-1];

for(let i =0;i<this.UnsatisfiedItemsData.length;i++){
if(cutteValue == this.UnsatisfiedItemsData[i]){

this.satisfiedItemsData = this.satisfiedItemsData.splice(0,value.length-1)
promptMessage('提示','您选择的满意项目与不满意项目冲突,请重新选择！');
}
}
},
getGrape(){
this.$nextTick(function(){

if(this.msgForm.score == 5){
this.serviceGrade = '很满意';
}else if(this.msgForm.score == 4){
this.serviceGrade = '满意';
}else if(this.msgForm.score == 3){
this.serviceGrade = '一般';
}else if(this.msgForm.score == 2){
this.serviceGrade = '不满意';
}else if(this.msgForm.score == 1){
this.serviceGrade = '非常不满意';
}else if(this.msgForm.score == 0){
this.serviceGrade = '';
}
})
},
getevaluateMsg(){
this.$store.commit('updateLoadingStatus', {isLoading: true});
fetch('post',urlConfig.dailyEvaluationMsg,this.paramData).then(response => {

if(typeof response.data === 'undefined'){ //已评价

this.evaluationDmDisabled = true;
this.getGrape();
this.msgForm = response;
this.$store.commit('updateLoadingStatus', {isLoading: false});
for(let i=0;i<response.ivfPatientEvaluateDList.length;i++){

if(response.ivfPatientEvaluateDList[i].evaluateType == 1){  // 满意

this.satisfiedOptions.push({'EVALUATEITEM':response.ivfPatientEvaluateDList[i].evaluateItem,'IVFPATIENTSCHDULEID':response.ivfPatientEvaluateDList[i].ivfPatientScheduleId});
this.satisfiedItemsData.push(response.ivfPatientEvaluateDList[i].ivfPatientScheduleId);

}else{  //不满意

this.UnsatisfiedOptions.push({'EVALUATEITEM':response.ivfPatientEvaluateDList[i].evaluateItem,'IVFPATIENTSCHDULEID':response.ivfPatientEvaluateDList[i].ivfPatientScheduleId});
this.UnsatisfiedItemsData.push(response.ivfPatientEvaluateDList[i].ivfPatientScheduleId);
}
}

}else if(response.data === null){ //未评价

this.getProject();
}

}).catch(function(error){
promptMessage('提示',error);
})
},   //获取评价信息
getProject(){
fetch('post',urlConfig.dailyEvaluationgetProject,this.paramData).then(response => {

this.$store.commit('updateLoadingStatus', {isLoading: false});
this.UnsatisfiedOptions = response;
this.satisfiedOptions = response;
if(response.length == 0){
this.$store.commit('updateLoadingStatus', {isLoading: true});
promptMessage('提示','获取评价项目失败,请联系身边医护人员或拨打客服电话027-82889968');

}

}).catch(function(error){
promptMessage('提示','获取评价项目失败！');
})
},
msgSubmit(){
this.msgForm.ivfPatientEvaluateDList = [];
this.msgForm.id = null;
this.msgForm.evaluateDate = this.evaluateDate;
this.msgForm.personInfoId = this.personInfoId;
if(this.msgForm.score != 0 && (this.UnsatisfiedItemsData.length || this.satisfiedItemsData.length)){
if(this.msgForm.score <= 2 && this.UnsatisfiedItemsData.length ==0 && this.msgForm.dissatisfiedContent.trim() == ''){
promptMessage('提示','请你选择具体不满意的服务环节或填写不满意事项的内容，以便于我们及时整改，谢谢您的配合！')
return false;
}else{
for(let i =0;i<this.UnsatisfiedOptions.length;i++){
for(let j=0;j<this.UnsatisfiedItemsData.length;j++){
if(this.UnsatisfiedItemsData[j] == this.UnsatisfiedOptions[i].IVFPATIENTSCHDULEID){
console.log(this.UnsatisfiedOptions[i],33)
this.msgForm.ivfPatientEvaluateDList.push({
"evaluateItem":this.UnsatisfiedOptions[i].EVALUATEITEM,
"evaluateType": "2",
"id": null,
"ivfPatientEvaluateHId": null,
"ivfPatientScheduleId": this.UnsatisfiedItemsData[j]
})
}
if(this.UnsatisfiedOptions[i].AREAID && this.UnsatisfiedOptions[i].AREAID!="" ){
this.msgForm.serviceHospital=this.UnsatisfiedOptions[i].AREAID;
}
}
}    //不满意项目
for(let i =0;i<this.satisfiedOptions.length;i++){
for(let j=0;j<this.satisfiedItemsData.length;j++){
if(this.satisfiedItemsData[j] == this.satisfiedOptions[i].IVFPATIENTSCHDULEID){
console.log(this.satisfiedOptions[i],33)
this.msgForm.ivfPatientEvaluateDList.push({
"evaluateItem":this.satisfiedOptions[i].EVALUATEITEM,
"evaluateType": "1",
"id": null,
"ivfPatientEvaluateHId": null,
"ivfPatientScheduleId": this.satisfiedItemsData[j]
})
}
if(this.satisfiedOptions[i].AREAID && this.satisfiedOptions[i].AREAID!="" ){
this.msgForm.serviceHospital=this.satisfiedOptions[i].AREAID;
}
}
}    //满意项目
/* console.log(this.msgForm,'提交')*/
fetch('post',urlConfig.dailyEvaluationsave,this.msgForm).then(response =>{

this.$router.push('/serviceSubmissionResult');

}).catch(function(error){
promptMessage('提示','提交失败,请重新提交！');
})
}


}else {

if(this.msgForm.score == 0){

promptMessage('提示','请为处理结果选星评分哦！')
}else{
promptMessage('提示','请选择您‘满意’或者‘不满意’的项目！')
}

}

},//提交
},
mounted() {

this.personInfoId = this.$route.query.personInfoId;
this.evaluateDate = this.$route.query.evaluateDate;
this.paramData = new URLSearchParams();
this.paramData.append('personInfoId',this.personInfoId);
this.paramData.append('evaluateDate',this.evaluateDate);
getken(this.getevaluateMsg);
}
}



// WEBPACK FOOTER //
// ./src/project/ValuationProject/dailyEvaluation.vue